import { projects as projectsAll } from '@/content';

export const filterByCompany = (company) => {
  const result = projectsAll.filter((project) => project.companies.includes(company));
  return result;
};

export const filterBySlug = (slug) => {
  const result = projectsAll.filter((project) => project.slug === slug);
  if (result.length > 0) {
    return result[0];
  }
  return null;
};

export const useProject = () => {
  const [project, setProject] = useState(null);

  return {
    project,
    filterBySlug: (slug) => setProject(filterBySlug(slug)),
  };
};

export const useProjects = () => {
  const [projects, setProjects] = useState([]);

  return {
    projects,
    filterByCompany: (company) => setProjects(filterByCompany(company)),
  };
};
